// import axios from 'axios';
import request from '@/utils/request'

export function albumInit() {
  return request({
    url: '/album/albumInit',
    method: 'get'
  })
}
// /获取首页感兴趣的数据
export function InterestedHome() {
  return request({
    url: 'main/mainInterested',
    method: 'get'
  })
}
// /首页初始化数据
export function getHomeInitData() {
  return request({
    url: 'main/mainInit',
    method: 'get'
  })
}
// /首页增加更多栏目数据
export function addMoreColumn(params) {
  return request({
    url: 'main/getColumnContent',
    method: 'get',
    params
  })
}
/* /首页增加更多栏目数据*/
export function getContentPager(params) {
  return request({
    url: 'main/getContentPager',
    method: 'get',
    params
  })
}

// //获取资讯页面初始化数据
export function getNewsInitData(params) {
  return request({
    url: 'content/contentInit',
    method: 'get',
    params
  })
}
// /加载更多资讯数据（通用）资讯，图集，视频，文库   ////首页的全部栏目加载更多
export function addMorenNews(params) {
  return request({
    url: 'main/getContentCurrency',
    method: 'get',
    params
  })
}
// 首页的全部栏目加载更多
export function getContentPagerExp5(params) {
  return request({
    url: 'main/getContentPagerExp5',
    method: 'get',
    params
  })
}
// //专辑初始化数据
export function getalbumInitData() {
  return request({
    url: 'album/albumInit',
    method: 'get'
  })
}
// ///增加专辑数据
export function addalbumData(params) {
  return request({
    url: 'album/albumPage',
    method: 'get',
    params
  })
}
// /////获取专题初始化数据
export function getspecialInitData() {
  return request({
    url: 'special/specialInit',
    method: 'get'
  })
}
// 增加专题数据
export function addspecialData(params) {
  return request({
    url: 'special/specialPage',
    method: 'get',
    params
  })
}
// //获取详情数据(资讯，视频，图片，文库)
export function getDetail(params) {
  return request({
    url: 'content/getCmsContentInfo',
    method: 'get',
    params
  })
}
// //获取按照栏目查看的数据
export function getColumnData(params) {
  return request({
    url: 'column/findContentPagerByColumnId',
    method: 'post',
    params
  })
}
// /获取栏目的信息，图片，标题
export function getColumnTopMessage(params) {
  return request({
    url: '/column/columnInfo',
    method: 'post',
    params
  })
}
// //右侧公共热门展示
export function getRightData() {
  return request({
    url: 'content/rightSidebar',
    method: 'get'
  })
}
// //新增评论
export function addSpeak(params) {
  return request({
    url: 'content/addCmsSpeak',
    method: 'get',
    params
  })
}
// /查询热门评论(一级评论，1为推荐热门)
export function hotSpeak(params) {
  return request({
    url: 'content/findCmsSpeakByContent',
    method: 'get',
    params
  })
}
// /查看子代评论
export function readSpeak(params) {
  return request({
    url: 'content/getChildrenSpeak',
    method: 'get',
    params
  })
}
// /登录验证
export function cheakLogin(params) {
  return request({
    url: '/user/login',
    method: 'post',
    params
  })
}
// /短信验证码
export function getVcode(params) {
  return request({
    url: '/cmsUser/validationCode',
    method: 'post',
    params
  })
}
// /注册验证
export function checkRegister(params) {
  return request({
    url: '/user/userRegister',
    method: 'post',
    params
  })
}
// 重置密码
export function resetPassword(params) {
  return request({
    url: '/user/resetPassword',
    method: 'post',
    params
  })
}

// 个人信息初始化
export function getInitMsg(params) {
  return request({
    url: '/user/findCmsUser',
    method: 'get',
    params
  })
}
// /地区
export function getFwFieldJsonByRegion(params) {
  return request({
    url: '/user/getFwFieldJsonByRegion',
    method: 'get',
    params
  })
}
// /修改个人信息
export function changeUserMsg(params) {
  return request({
    url: '/user/updateCmsUser',
    method: 'post',
    params
  })
}
// 修改个人信息初始化
export function msgChangeInit(params) {
  return request({
    url: '/user/editCmsUserInit',
    method: 'post',
    params
  })
}
// 我的收藏
export function findCmsUserUCMapPage(params) {
  return request({
    url: '/user/findCmsUserUCMapPage',
    method: 'get',
    params
  })
}
// //取消收藏
export function deleteCmsUCMap(params) {
  return request({
    url: '/user/deleteCmsUCMap',
    method: 'get',
    params
  })
}
// 新增收藏
export function addCollect(params) {
  return request({
    url: 'content/ContentCollection',
    method: 'get',
    params
  })
}

// /我的评论
export function myCommont(params) {
  return request({
    url: '/user/findCmsUserSpeakPage',
    methods: 'get',
    params
  })
}
// 删除评论
export function delMyCommont(params) {
  return request({
    url: '/content/delCmsSpeak',
    methods: 'post',
    params
  })
}
// //我的消息回复我的
export function replyMe(params) {
  return request({
    url: '/user/findCmsMessageReply',
    methods: 'get',
    params
  })
}
// /系统回复
export function replyxitong(params) {
  return request({
    url: '/user/findCmsMessagePage',
    methods: 'get',
    params
  })
}
// /修改密码
export function changePassWord(params) {
  return request({
    url: '/user/updateCmsUserPassword',
    methods: 'post',
    params
  })
}

// /解绑手机号
export function changePhone(params) {
  return request({
    url: '/cmsUser/updateUserPhone',
    methods: 'post',
    params
  })
}
// /专辑详情
export function albumDetail(params) {
  return request({
    url: 'album/albumDetails',
    methods: 'get',
    params
  })
}
// 获取专辑根目录下的第一条内容
export function getFirstAblumData(params) {
  return request({
    url: 'album/getFirstCatalogContent',
    methods: 'get',
    params
  })
}
// //上下篇的内容
export function getalbumContent(params) {
  return request({
    url: 'album/getAlbumtNextContent',
    methods: 'get',
    params
  })
}
// /专题详情数据
export function getStdData(params) {
  return request({
    url: '/special/specialDetailInit',
    methods: 'get',
    params
  })
}
export function getstdcontentData(params) {
  return request({
    url: '/special/getContentSpecial',
    methods: 'get',
    params
  })
}
// /content/contentReadingSizePlus
// /增加内容详情阅读量
export function addReadSize_content(params) {
  return request({
    url: '/content/contentReadingSizePlus',
    methods: 'get',
    params
  })
}
// /专辑阅读量加1
export function addReadSize_album(params) {
  return request({
    url: '/album/albumReadingSizePlus',
    methods: 'get',
    params
  })
}
// /怎加专题阅读量
export function addReadSize_special(params) {
  return request({
    url: '/special/specialReadingSizePlus',
    methods: 'get',
    params
  })
}
// /增加专辑收藏
export function addaollect_album(params) {
  return request({
    url: 'album/albumCollection',
    methods: 'get',
    params
  })
}
// /查询分类的字典（）
export function getClassz(params) {
  return request({
    url: '/dataShow/getClassz',
    methods: 'post',
    params
  })
}

// /查询谱书（传入display则为首页数据）
export function getDataBookList(params) {
  return request({
    url: '/dataBook/getDataBookList',
    methods: 'post',
    params
  })
}
// /查询谱文（传入display则为首页数据）
export function getDataArticleList(params) {
  return request({
    url: '/dataArticle/getDataArticleList',
    methods: 'post',
    params
  })
}
// /查询谱系（传入display则为首页数据）
export function getDataTreeList(params) {
  return request({
    url: '/dataTree/getDataTreeList',
    methods: 'post',
    params
  })
}
// /查询人物（传入display则为首页数据）
export function getdataNodeList(params) {
  return request({
    url: '/dataNode/getdataNodeList',
    methods: 'post',
    params
  })
}
// /查询页图（传入display则为首页数据）
export function getDataBookImgList(params) {
  return request({
    url: '/dataBookImg/getDataBookImgList',
    methods: 'post',
    params
  })
}
// /查询书页（传入display则为首页数据）
export function getDataArticlePageList(params) {
  return request({
    url: '/dataEditionHtml/getDataEditionHtmlList',
    methods: 'post',
    params
  })
}
// /谱书基础信息介绍
export function getBookNews(params) {
  return request({
    url: '/portalBook/getBookNews',
    methods: 'post',
    params
  })
}
// /谱书目录信息
export function getBookListCataLogList(params) {
  return request({
    url: '/portalBook/getBookListCataLogList',
    methods: 'post',
    params
  })
}
// /谱系基础信息介绍
export function getTreeNews(params) {
  return request({
    url: '/portalTree/getTreeNews',
    methods: 'post',
    params
  })
}
// /谱文基础信息介绍
export function getArticleNews(params) {
  return request({
    url: '/portalArticle/getArticleNews',
    methods: 'post',
    params
  })
}
// /人物基础信息介绍
export function getNodeNews(params) {
  return request({
    url: '/portalNode/getNodeNews',
    methods: 'post',
    params
  })
}
// /书页基础信息介绍
export function getEditionHtml(params) {
  return request({
    url: '/portalEditionHtml/getEditionHtml',
    methods: 'post',
    params
  })
}
// /页图基础信息介绍
export function getBookImgsNews(params) {
  return request({
    url: '/portalBookImg/getBookImgsNews',
    methods: 'post',
    params
  })
}
// /查询系统
export function getClassType() {
  return request({
    url: '/userAdmin/getClassz',
    method: 'get'
  })
}
export function getEditionHtmlLists(params) {
  return request({
    url: '/dataEditionHtml/getDataEditionHtmlList',
    method: 'post',
    params
  })
}
/*
*
* 查询用户是否收藏resId
* */
export function getResIsCollection(params) {
  return request({
    url: '/portalBook/getResIsCollection',
    method: 'post',
    params
  })
}
/*
*
* 用户取消收藏resId
* */
export function addUserCollection(params) {
  return request({
    url: '/portalBook/addUserCollection',
    method: 'post',
    params
  })
}
/*
*
* 查询系统分类
* */
export function getClasszSystem(params) {
  return request({
    url: '/userAdmin/getClassz',
    method: 'post',
    params
  })
}
/*
*
* 增加资源评论
* */
export function addResSpeak(params) {
  return request({
    url: '/portalBook/addResSpeak',
    method: 'post',
    params
  })
}
/*
*
* 查询资源一级评论
* */
export function getResSpeakLists(params) {
  return request({
    url: '/portalBook/getResSpeakLists',
    method: 'post',
    params
  })
}
/*
*
* 查询资源热门评论
* */
export function getResHotSpeak(params) {
  return request({
    url: '/portalBook/getResHotSpeak',
    method: 'post',
    params
  })
}
/*
*
* 查询子集评论
* */
export function getResSpeakListLow(params) {
  return request({
    url: '/portalBook/getResSpeakListLow',
    method: 'post',
    params
  })
}
/*
*
* 资源推荐
* */
export function getTJShow(params) {
  return request({
    url: '/portalBook/getTjShow',
    method: 'post',
    params
  })
}
/*
*
* 站内搜索10种
* */
export function getContextSS(params) {
  return request({
    url: '/main/getContextSS',
    method: 'post',
    params
  })
}
/*
*
* 登录退出
* */
export function userOutLogin(params) {
  return request({
    url: 'cmsUser/userOutLogin',
    method: 'post',
    params
  })
}

/**
 * 总数据库搜索
 */
export function searchRes(params) {
  return request({
    url: '/portalBook/searchRes',
    method: 'post',
    params
  })
}
/**
 * 谱阅权限验证
 */
export function getResIsTrue(params) {
  return request({
    url: '/portalBook/getResIsTrue',
    method: 'post',
    params
  })
}
/**
 * 谱阅密码权限验证
 */
export function getResPassworld(params) {
  return request({
    url: '/portalBook/getResPassworld',
    method: 'post',
    params
  })
}
// /预览前展示详情查看
export function getResNewIsAll(params) {
  return request({
    url: 'portalBook/getResNewIsAll',
    method: 'post',
    params
  })
}

// 微信换绑地址
export function getUpdateBindingUrl(params) {
  return request({
    url: 'cmsUser/getUpdateBindingUrl',
    method: 'post',
    params
  })
}
// 验证详情是否可用
export function getResIsLife(params) {
  return request({
    url: 'portalBook/getResIsLife',
    method: 'post',
    params
  })
}
// 详情推荐资源类型改版
export function getShowBookRecommend(params) {
  return request({
    url: 'portalBook/getShowBookRecommend',
    method: 'post',
    params
  })
}
// /预览权限验证
export function getResIsLook(params) {
  return request({
    url: 'dataReleaseApply/getResIsLook',
    method: 'post',
    params
  })
}
// /通行证初始化
export function loadIndex() {
  return request({
    url: 'passportUser/loadIndex',
    method: 'post'
  })
}
// /通行证我的钱包列表
export function findWallerDetails(params) {
  return request({
    url: 'passportWallet/findWallerDetails',
    method: 'post',
    params
  })
}
// /通行证我的钱包初始化
export function loadWallet(params) {
  return request({
    url: 'passportWallet/loadWallet',
    method: 'post',
    params
  })
}
// /通行证我的积分初始化
export function loadIntegral(params) {
  return request({
    url: 'passportIntegral/loadIntegral',
    method: 'post',
    params
  })
}
// /通行证我关注
export function findPassportFollow(params) {
  return request({
    url: 'passportUser/findPassportFollow',
    method: 'post',
    params
  })
}
// /通行证取消我关注
export function deletePassportFollow(params) {
  return request({
    url: 'passportUser/deletePassportFollow',
    method: 'post',
    params
  })
}

// /通行证关注我的
export function findFollowPassport(params) {
  return request({
    url: 'passportUser/findFollowPassport',
    method: 'post',
    params
  })
}
// /通行证关注用户操作
export function addPassportFollow(params) {
  return request({
    url: 'passportUser/addPassportFollow',
    method: 'post',
    params
  })
}
// /通行证用户是否关注
export function isWhetherFollow(params) {
  return request({
    url: 'passportFollow/isWhetherFollow',
    method: 'post',
    params
  })
}

export function getWeChatQr(params) {
  return request({
    url: 'portalBook/getWeChatQr',
    method: 'post',
    params
  })
}
// /商品列表初始化
export function getPayCommodityList(params) {
  return request({
    url: 'payCommodity/getPayCommodityList',
    method: 'post',
    params
  })
}
// /商品列表初始化
export function startPayRecharge(params) {
  return request({
    url: 'passportPayOrder/startPayRecharge',
    method: 'post',
    params
  })
}
// /充值扫码回调
export function verificationOrder(params) {
  return request({
    url: 'passportPayOrder/verificationOrder',
    method: 'post',
    params
  })
}
// /谱阅的收藏
export function findUserCollection(params) {
  return request({
    url: 'passportUser/findUserCollection',
    method: 'post',
    params
  })
}
// 谱阅的评论
export function findUserMessage(params) {
  return request({
    url: 'passportUser/findUserMessage',
    method: 'post',
    params
  })
}

// //推广中心
export function loadPublicity(params) {
  return request({
    url: 'passportPublicity/loadPublicity',
    method: 'post',
    params
  })
}
// /大谱师推广码
export function getPassportJointatQRcode(params) {
  return request({
    url: 'passportUser/getPassportJointatQRcode',
    method: 'post',
    params
  })
}

// /谱阅推广码
export function getPassportUserReaderQRcode(params) {
  return request({
    url: 'passportUser/getPassportUserReaderQRcode',
    method: 'post',
    params
  })
}

// /关注二维码

export function getPassportUserNewsQRcode(params) {
  return request({
    url: 'passportUser/getPassportUserNewsQRcode',
    method: 'post',
    params
  })
}
export function getUserPhoneRegisterUrl(params) {
  return request({
    url: 'user/getUserPhoneRegisterUrl',
    method: 'post',
    params
  })
}

export function phoneBindingCallback(params) {
  return request({
    url: 'user/phoneBindingCallback',
    method: 'post',
    params
  })
}
export function resAccessPermissions(params) {
  return request({
    url: 'user/resAccessPermissions',
    method: 'post',
    params
  })
}
export function startPayRulePc(params) {
  return request({
    url: 'user/startPayRulePc',
    method: 'post',
    params
  })
}
export function verificationReaderOrder(params) {
  return request({
    url: 'user/verificationReaderOrder',
    method: 'post',
    params
  })
}
// /上下篇资源
export function getShowResLoad(params) {
  return request({
    url: 'dataShow/getShowResLoad',
    method: 'post',
    params
  })
}

// /首页
export function ssoUserLogin(params) {
  return request({
    url: 'ssoLogin/ssoUserLogin',
    method: 'post',
    params
  })
}

// /通行证我的家谱数量
export function findUserFamilyTreeSize(params) {
  return request({
    url: 'passportUser/findUserFamilyTreeSize',
    method: 'post',
    params
  })
}
// /通行证我的家谱分页
export function findUserFamilyTree(params) {
  return request({
    url: 'passportUser/findUserFamilyTree',
    method: 'post',
    params
  })
}
// /通行证我的收藏数
export function findUserCollectionSize(params) {
  return request({
    url: '/passportUser/findUserCollectionSize',
    method: 'post',
    params
  })
}
// /通行证我的关注数
export function findPassportFollowSize(params) {
  return request({
    url: '/passportUser/findPassportFollowSize',
    method: 'post',
    params
  })
}
// /通行证我的打赏金额
export function findUserRewardSize(params) {
  return request({
    url: '/passportUser/findUserRewardSize',
    method: 'post',
    params
  })
}
// /通行证我的评论
export function findUserMessageSize(params) {
  return request({
    url: '/passportUser/findUserMessageSize',
    method: 'post',
    params
  })
}
// /通行证我的阅读记录
export function findLatelyRead(params) {
  return request({
    url: '/passportUser/findLatelyRead',
    method: 'post',
    params
  })
}
// /增加阅读量
export function addContentSize(params) {
  return request({
    url: 'portalBook/addContentSize',
    method: 'post',
    params
  })
}

